export default "__VITE_ASSET__DCuqCV_I__"